import { mapGetters } from "vuex";

export const appConfigurationMixin = {
  computed: {
    ...mapGetters({
      appConfiguration: "getAppConfiguration",
    }),
  },
};
